import { ethers } from "ethers";



export const getProvider = (ethereum) => ethereum ? new ethers.providers.Web3Provider(ethereum, 'any') : undefined;


